<script setup lang="ts">
/* The container for <ItemRow>s: a plain <ul> that goes edge to edge inside a
   <Panel flush>. One markup at every width -- the rows reflow themselves --
   so a list is never written twice, once as a table and once as cards. */
</script>

<template>
  <ul class="list"><slot /></ul>
</template>

<style scoped>
.list {
  list-style: none;
  margin: 0;
  padding: 0;
}
</style>
